<template>
  <div class="photo-card-list">
    <div class="card-item" v-for="(item,index) in data.cards" :key="index" @click="showModel(item)">
      <div class="photo">
        <img :src="item.img" alt />
      </div>
      <div class="text">
        <h4>{{ item.text }}</h4>
      </div>
    </div>
  </div>
</template>
<script setup>
import img01 from '@/assets/images/other/pic_1.png';
import img02 from '@/assets/images/other/pic_4.png';
import img03 from '@/assets/images/other/pic_5.png';
import img04 from '@/assets/images/other/pic_8.png';


import img05 from '@/assets/images/other/pic_10.png';
import img06 from '@/assets/images/other/pic_11.png';
import img07 from '@/assets/images/other/pic_13.png';
import img08 from '@/assets/images/other/pic_14.png';
import img09 from '@/assets/images/other/pic_15.png';

import { reactive } from 'vue-demi';
import $toast from '@/components/showModel';
const data = reactive({
  cards: [
    {
      img: img01,
      text: '有你更美，有礼更美” 美谷奉贤两周年特别活动',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=2c9fa4ab7a31c297017a322c3ea1004f&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1Y2RmNmQ5NDk4Nzk0ODM5YmEzODE4YTA2YzJmNGQ1ZjdmYzY7MzEwMTIwIiwiaWF0IjoxNjM0Mjg2MzQxLCJleHAiOjI2NzEwODYzNDF9.h8Xn4yvAjFQZL8ce-OIfhsFZ8wZARN6bjUaFzDp0VXoqYahhqYs2VzgfHDluTO0ta4H9pBlnUBg-n0HiOnGC_A'
    },
    {
      img: img02,
      text: '闵行花博会门票答题抽奖',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=2c9fa4a9782107290178b0fd63e7734e&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmNGYxMmJjM2JjZDQ0YWM1YTRhYjhlYmQ0MWJhN2JmOTszMTAxMTIiLCJpYXQiOjE2MzQyODYzNDIsImV4cCI6MjY3MTA4NjM0Mn0.Ht4bix03117jSDWt6ACWP4brDlpVDEedY1d--s9IMsAt-Bh_CZfm8MNQ8h4laQEHVmffXRaEVbTFVz1jRg4tAg'
    },
    {
      img: img03,
      text: '闵行车圈，免费洗车',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=2c9fa4a97b19e48e017b9bb503413fee&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmNGYxMmJjM2JjZDQ0YWM1YTRhYjhlYmQ0MWJhN2JmOTszMTAxMTIiLCJpYXQiOjE2MzQyODYzNDIsImV4cCI6MjY3MTA4NjM0Mn0.Ht4bix03117jSDWt6ACWP4brDlpVDEedY1d--s9IMsAt-Bh_CZfm8MNQ8h4laQEHVmffXRaEVbTFVz1jRg4tAg'
    },

    {
      img: img04,
      text: '徐汇-国防教育知识竞赛最新模板',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=2c9fa4ab7baada2c017bf69bcd4c77c8&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmNGYxMmJjM2JjZDQ0YWM1YTRhYjhlYmQ0MWJhN2JmOTszMTAxMDQiLCJpYXQiOjE2MzQyODYzNDMsImV4cCI6MjY3MTA4NjM0M30.KfNfjGfXMgLWRzXusa-YdV3Ok2N6CknXq6UkHsJa4UT6Gd6EiOAGXpT7WZZkWFeK060I-PcUcBAxYiYUilHl_w'
    },
    {
      img: img05,
      text: '杨浦-生产安全月线上知识竞赛',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=2c9fa4a978c5da0f017983e0da8e4bd9&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMTc3ODQxMTc5YTE0NDIzYmZhMmQwNGRkZDJkNTE0Njc4ODc7MzEwMTEwIiwiaWF0IjoxNjM0Mjg2MzQzLCJleHAiOjI2NzEwODYzNDN9.ts4M32_lCytu2G9lqTkmdacdaV0456_whPiw6drmBhMcCZRB5mcyoEo-pOOrDDW8qYfdOWlb5k8spfVyT24GIg'
    },
    {
      img: img06,
      text: '杨浦“第七次全国人口普查知识” 有奖问答活动',
      link:'https://activity-market.shmedia.tech/awardquestion/toIndex.do?&linkid=3e89d38278aa41a9acc8ac6904a29228&actId=40cd85b64c6e18aa8d9cdfbfeb5b3192&jwid=gh_835d899e19dc&type=h5&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMTc3ODQxMTc5YTE0NDIzYmZhMmQwNGRkZDJkNTE0Njc4ODc7MzEwMTEwIiwiaWF0IjoxNjM0Mjg2MzQzLCJleHAiOjI2NzEwODYzNDN9.ts4M32_lCytu2G9lqTkmdacdaV0456_whPiw6drmBhMcCZRB5mcyoEo-pOOrDDW8qYfdOWlb5k8spfVyT24GIg'
    }
  ]
})

const showModel = (data)=>{
  $toast({title:data.text,link:data.link})
}
</script>
<style lang="less" scoped>
.photo-card-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -20px;
  .card-item {
    width: 25%;
    padding: 0 20px;
    margin: 20px 0;
    transition: all 0.2s ease-out;
    
    .text {
      font-size: 18px;
      text-align: center;
      margin-top: 8px;
      height: 60px;
    }
    .photo {
      border-top-left-radius: 36px;
      border-top-right-radius: 36px;
      border:4px solid #fff;
      height: 472px;
      overflow: hidden;
      transition: all 0.2s ease-out;
      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit:cover;
      }
    }
    &:hover {
      cursor: pointer;
      .photo {
        box-shadow: 0 0 12px rgba(62, 71, 201, 0.4);
        transition: all 0.2s ease;
      }
      .text{
        color: var(--blue600);
       
      }
    }
  }
}
</style>
